<template>
  <div id="app-project">
    <div class="project-box">
      <div class="project-top">
        <h3>爱眼活动</h3>
        <div class="more-box">
          <h6>更多</h6>
          <p>more</p>
        </div>
        <div :class="{'border-box':classShow, 'animated': classHide, 'fadeInUpBig': classHide}"></div>
      </div>
      <div class="project-bottom">
        <el-row :gutter="20">
          <el-col :span="6" v-for="(item,index) in newList" :key="index">
            <div class="project-col">
              <div class="img-box">
                <img src="../../assets/images/project.png" alt>
              </div>
              <div class="content-box">
                <h3 class="iconfont">&#xe619; 活动进行中...</h3>
                <h5>{{item.title}}</h5>
                <ul>
                  <li>
                    <span>已报名</span>
                    <i>{{item.has}}</i>
                    <span>人</span>
                  </li>
                  <li>
                    <span>剩余名额</span>
                    <i>{{item.lave}}</i>
                    <span>人</span>
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      classShow: true,
      classHide: false,
      newList: [
        {
          id: 1,
          title: "“一带一路：侨爱心光明行”活动走进缅甸仰光",
          lave: "1258",
          has: "150"
        },
        {
          id: 1,
          title: "“一带一路：侨爱心光明行”活动走进缅甸仰光",
          lave: "1258",
          has: "150"
        },
        {
          id: 1,
          title: "“一带一路：侨爱心光明行”活动走进缅甸仰光",
          lave: "1258",
          has: "150"
        },
        {
          id: 1,
          title: "“一带一路：侨爱心光明行”活动走进缅甸仰光",
          lave: "1258",
          has: "150"
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
#app-project {
  width: 100%;
  margin: 85px 0;
}
.project-box {
  width: 1300px;
  margin: 0 auto;
  .project-top {
    position: relative;
    margin-bottom: 60px;
    > h3 {
      font-size: 30px;
      color: #000;
      font-weight: normal;
      padding: 14px 0;
    }
    .more-box {
      position: absolute;
      right: 0;
      top: 20px;
      > p {
        font-size: 12px;
        color: #333333;
      }
      > h6 {
        font-size: 14px;
        color: #333333;
      }
    }
    .border-box {
      width: 1300px;
      height: 1px;
      border: 1px solid #c30d23;
      border-bottom: 3px solid #c30d23;
    }
  }
  .project-bottom {
    .project-col {
      cursor: pointer;
      transition: ease-out 0.6s;
      &:hover {
        transform: scale(1.05);
        box-shadow: 0px 0px 35px 0px rgba(9, 1, 4, 0.21);
      }
      .img-box {
        width: 100%;
        height: 300px;
        > img {
          width: 100%;
          height: 100%;
        }
      }
      .content-box {
        padding: 20px 24px 20px 9px;
        > h3 {
          font-weight: normal;
          font-size: 16px;
          color: #c30d23;
          margin-bottom: 16px;
        }
        > h5 {
          font-size: 18px;
          color: #333;
          margin-bottom: 14px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        > ul {
          display: flex;
          > li {
            width: 50%;
            list-style: none;
            margin-top: 6px;
            overflow: hidden; /*超出部分隐藏*/
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出部分省略号显示*/
            > span {
              font-size: 14px;
              color: #999;
            }
            > i {
              font-style: normal;
              font-size: 16px;
              color: #333;
              font-weight: 700;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home/home_activity.vue